// context/PageInstanceContext.js
import { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { randomUUID } from '../utils/random';

const PageInstanceContext = createContext();

export function PageInstanceProvider({ children }) {
  const location = useLocation();
  const [pageInstanceId, setPageInstanceId] = useState(() => randomUUID());
  
  useEffect(() => {
    const newId = randomUUID();
    setPageInstanceId(newId);
    console.log("Routing", newId)
    window.pageInstanceId = newId; // Update window for ApiClient access
  }, [location.pathname]);
  
  return (
    <PageInstanceContext.Provider value={pageInstanceId}>
      {children}
    </PageInstanceContext.Provider>
  );
}

export const usePageInstanceId = () => useContext(PageInstanceContext);